<div class="custom-mat-dialog-form non-overflow">
  @if (newRow) {
    <h3 mat-dialog-title>{{title}}</h3>
  }
  @if (!newRow) {
    <h3 mat-dialog-title>Editing {{selected.Name}} - {{selected.Text}}</h3>
  }
  <div>
    <form [formGroup]="form">

      @if (newRow) {
        <div class="mt-2">
          <label>Event Type</label>
          <div class="input">
            <mat-select placeholder="EventType" name="EventType" required formControlName="EventType"
              title="Operation Mode"
              panelClass="testcase-class"
              class="form-control"
              (selectionChange)="onEventTypeChange($event)">
              @for (e of Events; track e) {
                <mat-option [value]="e.EventTypeId">
                  {{e.Description}}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
      }

      <!--Text-->
      @if (messageType === BLUEBOX) {
        <div class="mt-2">
          <label>BlueBox Event</label>
          <div class="input">
            <mat-select placeholder="Value" name="Value" required formControlName="Value"
              title="BlueBox Event"
              panelClass="testcase-class"
              class="form-control"
              (selectionChange)="onValueChange($event)">
              @for (value of blueBoxEventList | async; track value) {
                <mat-option [value]="value.BK">
                  ({{value.BK}}) - {{value.Description}}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
      }
      @if (messageType === OPERATION_MODE) {
        <div class="mt-2">
          <label>Operation Mode</label>
          <div class="input">
            <mat-select placeholder="Value" name="Value" required formControlName="Value"
              title="Operation Mode"
              panelClass="testcase-class"
              class="form-control"
              (selectionChange)="onValueChange($event)">
              @for (om of operationModes; track om; let i = $index) {
                <mat-option [value]="om.Value">
                  {{om.ModeReference}} ({{om.Value}})
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
      }
      @if (messageType === ERROR_CODE) {
        <div class="mt-2">
          <label>Error Code</label>
          <div class="input">
            <mat-select placeholder="Value" name="Value" required formControlName="Value"
              title="Error Code"
              panelClass="testcase-class"
              class="form-control"
              (selectionChange)="onValueChange($event)">
              @for (ec of errorCodes; track ec; let i = $index) {
                <mat-option [value]="ec.ErrorCode">
                  {{ec.ErrorCode}} - {{ec.Description}}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
      }
      @if (messageType === TRIP) {
        <div class="mt-2">
          <label>Start Floor</label>
          <div class="input">
            <input type="number" name="SFloor" required formControlName="SFloor"
              min="0"
              title="enter the number of start floor..."
              [ngClass]="classname[TEXT]"
              class="form-control"
              (change)="onFloorChange($event)" />
            </div>
            <label>End Floor</label>
            <div class="input">
              <input type="number" name="EFloor" required formControlName="EFloor"
                min="1"
                [ngClass]="classname[TEXT]"
                class="form-control"
                title="enter the number of end floor..."
                (change)="onFloorChange($event)" />
              </div>
            </div>
          }
          @if (messageType === DOOR_MOVEMENT) {
            <div class="mt-2">
              <label>Start State</label>
              <div class="input">
                <mat-select placeholder="SState" name="SState" required formControlName="SState"
                  title="Start State"
                  panelClass="testcase-class"
                  class="form-control"
                  (selectionChange)="onStartStateChange($event)">
                  @for (value of doorStateList | async; track value) {
                    <mat-option [value]="value.BK">
                      ({{value.BK}}) - {{value.Description}}
                    </mat-option>
                  }
                </mat-select>
              </div>
              <label>End State</label>
              <div class="input">
                <mat-select placeholder="EState" name="EState" required formControlName="EState"
                  title="Start State"
                  panelClass="testcase-class"
                  class="form-control"
                  (selectionChange)="onEndStateChange($event)">
                  @for (value of doorStateList | async; track value) {
                    <mat-option [value]="value.BK">
                      ({{value.BK}}) - {{value.Description}}
                    </mat-option>
                  }
                </mat-select>
              </div>
              <label>Floor</label>
              <div class="input">
                <input type="number" name="Floor" required formControlName="Floor"
                  min="0"
                  title="enter the number of the floor where the door movement happened"
                  [ngClass]="classname[TEXT]"
                  class="form-control"
                  (change)="onDoorFloorChange()" />
                </div>
              </div>
            }
            <div class="mt-2">
              <label>{{header[MILISECONDS].label}}</label>
              <div class="input">
                <input type="number" name="Miliseconds" required formControlName="Miliseconds"
                  title="{{header[MILISECONDS].label}}"
                  class="form-control"
                  (change)="onMilisecondsChange($event)">
                </div>
              </div>

              <!--Output-->
              @if (messageType !== OPERATION_MODE) {
                <div class="mt-2">&nbsp;</div>
              }
              @if (messageType === OPERATION_MODE && !newRow) {
                <div class="mt-2">
                  <div class="input">
                    <mat-checkbox name="Output"
                      title="{{header[OUTPUT].label}}"
                      (change)="onOutputChange($event)">
                      {{header[OUTPUT].label}}
                    </mat-checkbox>
                  </div>
                </div>
              }


              @if (!newRow) {
                <div class="mt-2 right">
                  <button matTooltip="Save" [disabled]="!form.valid" (click)="onSubmit()"
                    class="btn btn-primary">
                    Save
                  </button>
                  <button matTooltip="Cancel" (click)="onCancelForm()"
                    class="btn btn-danger">
                    Back
                  </button>
                </div>
              }

              @if (newRow) {
                <div class="mt-2 right">
                  <button [disabled]="!form.valid" (click)="onSubmit()" class="btn btn-primary">Save</button> <!--[mat-dialog-close]="1"-->
                  <button (click)="onCancelForm()" tabindex="-1" class="btn btn-danger">Cancel</button>
                </div>
              }

            </form>
          </div>
        </div>